export default ms => new Promise(res => setTimeout(res, ms));
